import { type PayloadAction, createSlice } from '@reduxjs/toolkit';

export type TakeControlDialogState = {
  open: boolean;
  instanceId?: number;
  controllingUserId?: string | null;
};

export type AppState = {
  takeControlDialog: TakeControlDialogState;
};

const initialState: AppState = {
  takeControlDialog: {
    open: false,
    instanceId: undefined,
    controllingUserId: undefined,
  },
};

const appSlice = createSlice({
  name: 'app',
  initialState,
  reducers: {
    setTakeControlDialog: (state, { payload }: PayloadAction<TakeControlDialogState>) => {
      state.takeControlDialog = payload;
    },
  },
});

export const { setTakeControlDialog } = appSlice.actions;

export default appSlice.reducer;
